import { Constants } from './Constants'

export const appendAdobeAnalytics = () => {
  var script = document.createElement('script') // create a script DOM node
  const url =
    Constants.NODE_ENV.toLowerCase() !== 'production'
      ? 'https://assets.adobedtm.com/launch-EN3fdba9159ab74025b0142efa5db4d90b-development.min.js'
      : 'https://assets.adobedtm.com/52e6c31223bb/d39c1c648e76/launch-EN2a7c2ef32e9748839b178d294225289f.min.js'

  script.setAttribute('src', url)
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('async', 'true')

  document.head.prepend(script)
}
